import {
  Card,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Link,
  FormControlLabel,
  Checkbox,
  Button,
  CircularProgress,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import { CreditCard, Email, Event, Face, Lock, PhoneAndroid, TextFields, VisibilityOffOutlined, VisibilityOutlined } from "@material-ui/icons";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PolicyModal from "../MetaForms/PolicyModal";
import moment from "moment";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import LangSelect from "../Navigation/LangSelect";

const psVInitialState = {
  ps1: false,
  ps2: false,
};

const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const SignUpForm = ({ formationGroups, customFields, isPreview, formName, sendformData, isSigningUp, setIsSigningUp }) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const [name, setName] = useState("");
  const [DNI, setDNI] = useState("");
  const [surname1, setSurname1] = useState("");
  const [surname2, setSurname2] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isBirthDayOpen, setIsBirthDayOpen] = useState(false);

  const [email, setEmail] = useState("");
  const [pass1, setPass1] = useState("");
  const [pass2, setPass2] = useState("");
  const [birthday, setBirthday] = useState(null);
  const [psw2focused, setPsw2focused] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(psVInitialState);
  const [defaultLang, setDefaultLang] = useState("spanish");
  const [policityOpen, setPolicityOpen] = useState(false);
  const [OS, setOS] = useState("Android");
  const [policityCheck1, setPolicityCheck1] = useState(false);
  const [policityCheck2, setPolicityCheck2] = useState(false);
  const [formError, setFormError] = useState({});
  const [selectedGroup, setSelectedGroup] = useState("");

  useEffect(() => {
    if (!!formationGroups) {
      const lgth = formationGroups.length;
      let available = 0;
      let firstAvailable;
      formationGroups.forEach((ws, i) => {
        if (ws.remaining > 0) {
          firstAvailable = available == 0 ? i : firstAvailable;
          available++;
        }
      });
      available == 1 && setSelectedGroup(firstAvailable);
    }
  }, [formationGroups]);

  const isValid =
    policityCheck1 &&
    selectedGroup !== "" &&
    name !== "" &&
    surname1 !== "" &&
    phoneNumber !== "" &&
    DNI !== "" &&
    email !== "" &&
    pass1 !== "" &&
    psw2focused &&
    psw2focused &&
    pass1 === pass2 &&
    !!birthday &&
    Object.keys(formError).every((k) => formError[k] === null);

  const checkPassword = (pw1, pw2) => {
    var aux = formError;
    if (pw1.length < 6) {
      aux["psw"] = t("lengthlessthan6");
    } else if (pw2 !== pw1 && psw2focused) {
      aux["psw"] = t("passwordNoMatch");
      aux["psw2"] = t("passwordNoMatch");
    } else {
      aux["psw"] = null;
      aux["psw2"] = null;
    }
    updateformError(aux);
  };

  const checkNotNull = (value, field) => {
    var aux = formError;
    value = value.trim();
    aux[field] = value == "" ? t("notEmptyField") : null;
    updateformError(aux);
  };

  const checkPhone = (value) => {
    var aux = formError;
    const rege1 = new RegExp("^[+]?[(]?[0-9]{1,3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$");
    const rege2 = new RegExp("^([+]*[(][0-9]{1,3}[)])?([+]*[0-9]{2})?[\\s]?([0-9]{2,4}[\\s.-]?){2,4}$");

    if (value == "") {
      checkNotNull(value, "phoneNumber");
    } else {
      if (rege1.test(value) || rege2.test(value)) {
        aux["phoneNumber"] = null;
      } else {
        aux["phoneNumber"] = t("invalidFormt");
      }
      // necesario para actualiar el estado en el mismo ciclo
      updateformError(aux);
    }
  };

  const checkDate = (date) => {
    moment(date).isValid();
    var aux = formError;
    aux["birthDay"] = !moment(date).isValid() ? t("invalidFormt") : null;
    updateformError(aux);
  };

  const checkDNI = (value) => {
    value = value.trim();
    var aux = formError;
    aux["DNI"] = !validDNIorPassport(value) ? t("dnibadFormat") : null;

    updateformError(aux);
  };

  const checkEmail = (email) => {
    var aux = formError;
    const rege = new RegExp(emailPattern);
    if (email == "") {
      checkNotNull(email, "email");
    } else {
      aux["email"] = !rege.test(email) ? t("invalidFormt") : null;
    }
  };

  const checkDataAndCreate = () => {
    let account = {
      email: email,
      name: name,
      surname1: surname1,
      surname2: surname2,
      lang: defaultLang,
      phone: phoneNumber,
      dni: DNI,
      birthday: birthday,
      workshop: selectedGroup,
      password: pass1,
      auth: policityCheck1,
      comunications: policityCheck2,
      OS: OS,
    };

    if (isValid) {
      setIsSigningUp(true);
      sendformData(account);
    }
  };

  const updateformError = (aux) => {
    var elem = {};
    Object.keys(aux).forEach((k) => (elem[k] = aux[k]));
    setFormError(elem);
  };

  return (
    <Grid container item xs={12} spacing={4} justify="center">
      <Card style={{ padding: 24, borderRadius: 16 }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="h5" style={{ fontWeight: 700, fontSize: 24, marginBottom: 12 }} color="primary">
              {formName[i18n.language.split("-")[0]]}
            </Typography>
            <Typography variant="h6" color="textSecondary">
              {t("completeFormationForm")}
              <Typography variant="body2">{t("fieldsRequired")}</Typography>
            </Typography>
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={12} container justify="space-between">
              <Typography variant="h6" color="textSecondary">
                {t("personalFields")}
              </Typography>
              <Typography>
                {t("selectLang")} <LangSelect />
              </Typography>
            </Grid>

            <Grid item xs={12} md={5}>
              <TextField
                id="name"
                variant="outlined"
                name="name"
                value={name}
                onBlur={() => {
                  setName(name.trim());
                  checkNotNull(name, "name");
                }}
                helperText={formError.name}
                error={!!formError.name}
                onChange={(e) => {
                  e = e.target.value;
                  setName(e);
                  !!formError.name && checkNotNull(e, "name");
                }}
                type="text"
                required
                label={t("name")}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Face color={!!formError.name ? "error" : "primary"} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={7}>
              <TextField
                id="surname1"
                variant="outlined"
                name="surname1"
                value={surname1}
                onBlur={() => {
                  setSurname1(surname1.trim());
                  checkNotNull(surname1, "surname1");
                }}
                helperText={formError.surname1}
                error={!!formError.surname1}
                onChange={(e) => {
                  e = e.target.value;
                  setSurname1(e);
                  !!formError.surname1 && checkNotNull(e, "surname1");
                }}
                type="text"
                required
                label={t("ape1")}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <TextFields color={!!formError.surname1 ? "error" : "primary"} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <TextField
                id="surname2"
                variant="outlined"
                name="surname2"
                value={surname2}
                onChange={(e) => setSurname2(e.target.value)}
                onBlur={() => setSurname2(surname2.trim())}
                type="text"
                label={t("ape2")}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <TextFields color="primary" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="group-select-label">{t("contactLang")}</InputLabel>
                <Select
                  labelId="group-select-label"
                  value={defaultLang}
                  onChange={(e) => setDefaultLang(e.target.value)}
                  label={t("contactLang")}
                  inputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <TextFields color="primary" />
                      </InputAdornment>
                    ),
                  }}
                >
                  {["spanish", "basque"].map((e) => (
                    <MenuItem value={e}>{t(`lang.${e}`)}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="group-select-label">{t("SO_de_su_movil")}</InputLabel>
                <Select
                  labelId="group-select-label"
                  value={OS}
                  onChange={(e) => setOS(e.target.value)}
                  label={t("SO_de_su_movil")}
                  inputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <TextFields color="primary" />
                      </InputAdornment>
                    ),
                  }}
                >
                  {["Android", "IOS", "other"].map((e) => (
                    <MenuItem value={e}>{t(e)}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                id="phoneNumber"
                variant="outlined"
                name="phoneNumber"
                value={phoneNumber}
                helperText={formError.phoneNumber}
                error={!!formError.phoneNumber}
                onBlur={(e) => {
                  checkPhone(e.target.value);
                }}
                onChange={(e) => {
                  e = e.target.value;
                  setPhoneNumber(e);
                  !!formError.phoneNumber && checkPhone(e);
                }}
                type="tel"
                required
                label={t("phoneNumber")}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PhoneAndroid color={!!formError.phoneNumber ? "error" : "primary"} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                id="DNI"
                variant="outlined"
                name="DNI"
                value={DNI}
                helperText={formError.DNI}
                error={!!formError.DNI}
                onBlur={(e) => checkDNI(e.target.value)}
                onChange={(e) => {
                  let v = e.target.value.toUpperCase();
                  setDNI(v);
                  !!formError.DNI && checkDNI(v);
                }}
                type="text"
                required
                label={t("dni")}
                fullWidth
                inputProps={{ maxLength: 9 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CreditCard color="primary" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDatePicker
                  autoOk
                  fullWidth
                  variant="inline"
                  inputVariant="outlined"
                  label={t("birthDay")}
                  format="DD/MM/YYYY"
                  value={birthday}
                  required
                  maxDate={new Date()}
                  maxDateMessage={t("maxDateMessage")}
                  minDateMessage={t("minDateMessage")}
                  invalidDateMessage={t("invalidDateMessage")}
                  InputAdornmentProps={{ position: "none" }}
                  open={isBirthDayOpen}
                  onOpen={() => setIsBirthDayOpen(true)}
                  onClose={() => {
                    setIsBirthDayOpen(false);
                    !!formError.birthDay && checkDate(birthday);
                  }}
                  onChange={(date) => {
                    setBirthday(date);
                    !!formError.birthDay && checkDate(date);
                  }}
                  onBlur={(date) => checkDate(date)}
                  /*onError={(err) => {
                    var aux = formError;
                    aux["birthDay"] = err == "" ? null : err;
                  }}*/
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton
                          onClick={() => {
                            setIsBirthDayOpen(true);
                          }}
                        >
                          <Event color="primary" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>

          <Grid item container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" color="textSecondary">
                {t("formationPlace")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="group-select-label">{t("selectGroup")} </InputLabel>
                <Select labelId="group-select-label" value={selectedGroup} onChange={(e) => setSelectedGroup(e.target.value)} label={t("selectGroup")}>
                  {!!formationGroups &&
                    formationGroups.map((e, i) => (
                      <MenuItem value={i} disabled={e.remaining == 0}>
                        <ListItemText primary={moment(e.time).format("dddd DD MMMM HH:mm")} secondary={`${e.remaining == 0 ? t("completedGroup") : ""}${e.text.split("· ")[0]}`} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {!!customFields && (
            <Grid item container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" color="textSecondary">
                  Datos adicionales
                </Typography>
              </Grid>
            </Grid>
          )}

          <Grid item container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" color="textSecondary">
                {t("reanibexAccount")}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                id="email"
                variant="outlined"
                name="email"
                value={email}
                helperText={formError.email}
                error={!!formError.email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  !!formError.email && checkEmail(e.target.value);
                }}
                onBlur={() => checkEmail(email)}
                type="email"
                required
                label={t("email")}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Email color="primary" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                required
                id="password"
                variant="outlined"
                name="password1"
                value={pass1}
                helperText={formError.psw}
                error={!!formError.psw}
                onChange={(e) => {
                  e = e.target.value;
                  setPass1(e);
                  !!formError.psw && checkPassword(e, pass2);
                }}
                onBlur={() => checkPassword(pass1, pass2)}
                type={passwordVisible.ps1 ? "text" : "password"}
                label={t("password")}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock color="primary" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        onClick={() => {
                          setPasswordVisible({
                            ...passwordVisible,
                            ps1: !passwordVisible.ps1,
                          });
                        }}
                      >
                        {passwordVisible.ps1 ? <VisibilityOffOutlined color="primary" /> : <VisibilityOutlined />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                required
                id="password2"
                variant="outlined"
                name="password2"
                value={pass2}
                helperText={formError.psw2}
                error={!!formError.psw2}
                onChange={(e) => {
                  e = e.target.value;
                  setPass2(e);
                  !!formError.psw2 && checkPassword(pass1, e);
                }}
                onBlur={() => checkPassword(pass1, pass2)}
                onFocus={() => {
                  setPsw2focused(true);
                }}
                type={passwordVisible.ps2 ? "text" : "password"}
                label={t("repeatPassword")}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock color="primary" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        onClick={() => {
                          setPasswordVisible({
                            ...passwordVisible,
                            ps2: !passwordVisible.ps2,
                          });
                        }}
                      >
                        {passwordVisible.ps2 ? <VisibilityOffOutlined color="primary" /> : <VisibilityOutlined />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} container justify="center">
            <Link href="#" onClick={() => setPolicityOpen(true)} variant="body2">
              {t("confPolicity")}
            </Link>
          </Grid>

          <Grid container item xs={12} spacing={1}>
            <Grid container item xs={12} justify="flex-start">
              <Grid item xs={12} container>
                <FormControlLabel control={<Checkbox checked={policityCheck2} onChange={() => setPolicityCheck2(!policityCheck2)} />} label={t("comunicationsLabel")} />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel control={<Checkbox checked={policityCheck1} onChange={() => setPolicityCheck1(!policityCheck1)} />} label={t("authorizationLabel")} />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" color="error">
                {t("authoritationHelper")}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Card>
      <Grid item xs={6} container justify="flex-start">
        {!isPreview && (
          <Button
            variant="contained"
            color="secondary"
            style={{
              borderRadius: 16,
              height: 48,
              textTransform: "none",
              alignSelf: "flex-start",
            }}
            onClick={() => history.push(ROUTES.SIGN_IN)}
          >
            {t("iGotAccoung")}
          </Button>
        )}
      </Grid>
      <Grid item xs={6} container justify="flex-end">
        {!isPreview && (
          <Button
            variant="contained"
            color="primary"
            disabled={!isValid || isSigningUp}
            style={{
              borderRadius: 16,
              height: 48,
              textTransform: "none",
              alignSelf: "flex-end",
              color: "#fff",
            }}
            onClick={checkDataAndCreate}
          >
            {t("createAccount")}
            {isSigningUp && (
              <CircularProgress
                size={24}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: -12,
                  marginLeft: -12,
                }}
              />
            )}
          </Button>
        )}
      </Grid>
      <PolicyModal open={policityOpen} set={setPolicityOpen} />
    </Grid>
  );
};

export default SignUpForm;

const validDNIorPassport = (value) => {
  const validChars = "TRWAGMYFPDXBNJZSQVHLCKET";
  const nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
  const nieRexp = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
  // Pasaporte “típico” letra + 8 dígitos
  const passportStrict = /^[A-Z]{1}[0-9]{8}$/i;
  // Pasaporte “flexible” 6–15 caracteres alfanuméricos
  const passportFlexible = /^[A-Z0-9]{6,15}$/i;

  value = value ? value.toString().trim().toUpperCase() : "";

  // NIF/NIE
  if (nifRexp.test(value) || nieRexp.test(value)) {
    const nie = value.replace(/^[X]/, "0").replace(/^[Y]/, "1").replace(/^[Z]/, "2");
    const letter = value.slice(-1);
    const charIndex = parseInt(nie.substr(0, 8), 10) % 23;
    return validChars.charAt(charIndex) === letter;
  }

  // Pasaportes
  if (passportStrict.test(value) || passportFlexible.test(value)) return true;

  return false;
};

const validPhone = (value) => {
  const rege1 = new RegExp("^[+]?[(]?[0-9]{1,3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$");
  const rege2 = new RegExp("^([+]*[(][0-9]{1,3}[)])?([+]*[0-9]{2})?[\\s]?([0-9]{2,4}[\\s.-]?){2,4}$");
  return rege1.test(value) || rege2.test(value);
};

export const isValidDNI = validDNIorPassport;
export const isValidPhone = validPhone;
